import { defineComponent as _defineComponent } from 'vue'
import IndustryTag from '@/views/profile/components/IndustryTag.vue';
import { PropType } from 'vue';
import { Industry } from '@/models/Tags';
import { useVModel } from '@vueuse/core';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'IndustryTags',
  props: {
  industries: {
    type: Array as PropType<Industry[]>,
    default: () => []
  }
},
  setup(__props) {

const props = __props;



const industries = useVModel(props, 'industries');

// Methoden
const removeIndustry = (id: string) => {
  const idx = industries.value.findIndex((item) => item.externalId === id);
  if (idx >= 0) {
    industries.value.splice(idx, 1);
  }
};

return { __sfc: true,props, industries, removeIndustry, IndustryTag }
}

})